import { createFileRoute } from '@tanstack/react-router'
import ReportPreview from '../../../../../../containers/Reports/components/report-preview'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/reports/$reportId/'
)({
  component: ReportPreview
})
